var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.383,
    height: 18,
    viewBox: "0 0 19.383 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.383,
    height: 18,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "product-services",
    transform: "translate(-5812 -21106.695)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6768",
    "data-name": "Path 6768",
    d: "M0,0H14.5l-3.71,8H1.943Z",
    transform: "translate(5816 21111)",
    fill: "#b1cbff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart",
    transform: "translate(5812 21106.695)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M15.5,18A1.5,1.5,0,1,1,17,16.5,1.5,1.5,0,0,1,15.5,18Zm-10,0A1.5,1.5,0,1,1,7,16.5,1.5,1.5,0,0,1,5.5,18ZM15,13H6a1,1,0,0,1-.966-.736L2.236,2H1A1,1,0,1,1,1,0H3a1,1,0,0,1,.966.737L4.582,3h12.8a2,2,0,0,1,1.789,2.894l-3.276,6.553A1,1,0,0,1,15,13ZM5.127,5l1.637,6h7.618l3-6H5.127Z",
    transform: "translate(0)",
    fill: "#1b145e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductServices);
export default __webpack_public_path__ + "static/media/product-services.fb3bf542c4d2394e7420f251d75eb0db.svg";
export { ForwardRef as ReactComponent };